// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Revisie.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
const effect = () => [
    {
        type: InGameEffect.revision,
        description: 'Revisie verwijdert de opgebouwde slijtage, maar lost geen storing op.',
    },
];
export const RevisieTaken = [
    {
        _id: 'revisie0',
        type: TaskType.revisie,
        title: 'Revisie',
        cost: 1500,
        description: 'Breng de machine terug naar nieuwstaat',
        inGameEffectDescription: 'Revisie verwijdert de opgebouwde slijtage, maar lost geen storing op',
        inGameEffect: [InGameEffect.revision],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 2,
        taskEffects: effect(),
    },
    {
        _id: 'revisie1',
        type: TaskType.revisie,
        title: 'Revisie',
        cost: 1500,
        description: 'Breng de machine terug naar nieuwstaat',
        inGameEffectDescription: 'Revisie verwijdert de opgebouwde slijtage, maar lost geen storing op',
        inGameEffect: [InGameEffect.revision],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 2,
        taskEffects: effect(),
    },
];
